export const convertReducersToSectionReducers = (section, sectionReducers) => {
    return Object.keys(sectionReducers)
        .reduce((acc, action) => {
        const originalReducer = sectionReducers[action];
        acc[action] = (params) => {
            const subPartialState = originalReducer(Object.assign(Object.assign({}, params), { state: params.state[section] }))
                || {};
            return Object.assign(Object.assign({}, params.state), { [section]: Object.assign(Object.assign({}, params.state[section]), subPartialState) });
        };
        return acc;
    }, {});
};
